import { graphql, commitMutation } from 'react-relay/legacy';
import { executeCaptcha } from 'dibs-recaptcha/exports/recaptcha';

const mutation = graphql`
    mutation RenderItemEmailMutation($input: RenderItemEmailInput!) {
        renderItemEmail(input: $input) {
            clientMutationId
        }
    }
`;

const commit = async (environment, args) => {
    const {
        message,
        recipientEmails,
        senderEmail,
        senderName,
        itemId,
        skuId,
        onCompleted,
        onError,
    } = args;
    const { captchaToken } = await executeCaptcha({
        featureFlag: 'emailPdpShareItemCaptcha',
        relayEnvironment: environment,
    });

    const input = {
        message,
        recipientEmails,
        senderEmail,
        senderName,
        itemId,
        skuId,
        captchaToken,
    };

    commitMutation(environment, {
        mutation,
        variables: {
            input,
        },
        onCompleted,
        onError,
    });
};

export default { commit };
